import { Controller } from '@hotwired/stimulus';

// Reloads the current page with the selected locale applied. The server-side
// `set_locale` before_action persists `params[:locale]` into the session.
export default class extends Controller {
  change(event) {
    const url = new URL(window.location.href);
    url.searchParams.set('locale', event.target.value);
    window.location.href = url.toString();
  }
}
